export default __webpack_public_path__ + "static/media/accessory.0fce2d5b.svg";